var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStep3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6E5FE",
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.862 12.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L18.582 24.07a4.5 4.5 0 0 1-1.897 1.13L14 26l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931zm0 0 2.638 2.638M26 22v4.75A2.25 2.25 0 0 1 23.75 29h-10.5A2.25 2.25 0 0 1 11 26.75v-10.5A2.25 2.25 0 0 1 13.25 14H18",
    stroke: "#821BB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep3);
export default __webpack_public_path__ + "static/media/icon-step-3.f568116d4aeecb0668152b1add30e798.svg";
export { ForwardRef as ReactComponent };